module.exports = __webpack_public_path__ + "static/media/american_Express_logo.e74659da.png";